import React from 'react';
import BaseAnimation from './BaseAnimation.js';
import 'react-spring/renderprops.cjs';

var GrowRight = function GrowRight(_ref) {
  var _ref$keys = _ref.keys,
      keys = _ref$keys === void 0 ? undefined : _ref$keys,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? undefined : _ref$items,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 200 : _ref$duration,
      _ref$from = _ref.from,
      from = _ref$from === void 0 ? 0 : _ref$from,
      _ref$to = _ref.to,
      to = _ref$to === void 0 ? 1 : _ref$to,
      children = _ref.children,
      _ref$onRest = _ref.onRest,
      onRest = _ref$onRest === void 0 ? function () {
    return null;
  } : _ref$onRest;
  return /*#__PURE__*/React.createElement(BaseAnimation, {
    duration: duration,
    enter: {
      opacity: "".concat(to),
      transform: 'translateX(0px)'
    },
    from: {
      opacity: "".concat(from),
      transform: 'translateX(100%)'
    },
    items: items,
    keys: keys,
    leave: {
      opacity: "".concat(from),
      transform: 'translateX(100%)'
    },
    onRest: onRest
  }, children);
};

export default GrowRight;
//# sourceMappingURL=GrowRight.js.map
